import { render, staticRenderFns } from "./PendingAccounts.vue?vue&type=template&id=34553186&scoped=true&"
import script from "./PendingAccounts.vue?vue&type=script&lang=ts&"
export * from "./PendingAccounts.vue?vue&type=script&lang=ts&"
import style0 from "./PendingAccounts.vue?vue&type=style&index=0&id=34553186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34553186",
  null
  
)

export default component.exports